import React, { useContext } from 'react';
import { CardMeta, MetaItem, DueDateBadge } from '../styles/Card.styles';
import { getDueDateStatus } from '../utils/dateUtils';
import { parseISO, format } from 'date-fns';
import { CommentIcon } from './icons/CommentIcon';
import { ChecklistIcon } from './icons/ChecklistIcon';
import { ClockIcon } from './icons/ClockIcon'; // Assuming you have a ClockIcon
import { BookmarkIcon } from './icons/BookmarkIcon';
import GithubIcon from './icons/GithubIcon'; // Import GithubIcon
import { useSaves } from '../hooks/useSaves';
import { useAuth } from '../contexts/AuthContext';

const CardMetaInfo = ({ card, enableGithubLinks }) => { // Add enableGithubLinks prop
    const { user } = useAuth();
    const { addSave } = useSaves(user?.uid);

    const checklistItems = card.checklists?.reduce((total, list) =>
        total + list.items.length, 0) || 0;
    const completedItems = card.checklists?.reduce((total, list) =>
        total + list.items.filter(item => item.completed).length, 0) || 0;

    let dueDateInfo = null;
    if (card.dueDate) {
        const parsedDate = parseISO(card.dueDate);
        const status = getDueDateStatus(parsedDate, card.isDueDateCompleted);
        const formattedDate = format(parsedDate, 'MMM d');

        // Determine text color based on badge color for better contrast if needed
        // For simplicity, using the default white or a specified one.
        let textColor = 'white';
        if (status.color === '#FFAB00') { // Example: Amber/Orange might need darker text
            textColor = '#172B4D'; // Dark gray/blue
        }


        dueDateInfo = (
            <DueDateBadge
                color={status.status === 'completed' ? undefined : status.color}
                textColor={status.status === 'completed' ? 'white' : textColor}
                className={status.status === 'completed' ? 'completed' : ''}
                title={status.text + (status.status !== 'completed' ? ` - ${format(parsedDate, 'MMM d, yyyy h:mm a')}` : '')}
            >
                <ClockIcon />
                {formattedDate}
            </DueDateBadge>
        );
    }

    return (
        <CardMeta>
            {dueDateInfo}
            {checklistItems > 0 && (
                <MetaItem>
                    <ChecklistIcon />
                    {completedItems}/{checklistItems}
                </MetaItem>
            )}
            {card.comments?.length > 0 && (
                <MetaItem>
                    <CommentIcon />
                    {card.comments.length}
                </MetaItem>
            )}
            {enableGithubLinks && card.githubUrl && ( // Check enableGithubLinks here
                <MetaItem title="View GitHub PR">
                    <a href={card.githubUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', color: 'inherit', textDecoration: 'none' }}>
                        <GithubIcon />
                    </a>
                </MetaItem>
            )}
            <MetaItem onClick={() => addSave(user?.uid, card.url)} title="Save this card">
                <BookmarkIcon color="#007bff" />
            </MetaItem>
        </CardMeta>
    );
};

export default CardMetaInfo;
